import { render, staticRenderFns } from "./channelEdit.vue?vue&type=template&id=09ebf1ed&"
import script from "./channelEdit.vue?vue&type=script&lang=js&"
export * from "./channelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports